/**
 * @author        quanquan
 * @dateTime      2020-07-29 10:27:30
 * @description
 */
import router from '@/conf/home/router'
import store from '@/conf/home/store'
import MC from '@/module/MC'
import NProgress from 'nprogress'
import { Message } from 'element'

NProgress.configure({ showSpinner: false })

const whiteList = ['/app-login', '/app-check', '/app-error401', '/app-jump/call-back', '/app-jump/author-health', '/app-jump/author-hdsec', '/app-jump/ewx-login'] // 权限白名单

const setTitle = ({ appName, title }) => {
  document.title = `${appName || '商户管理中台'}${title ? `-${title}` : ''}`
}

const frLoginPath = `${process.env.NODE_ENV === 'production' ? window.location.origin : 'https://merchants.jk.cn'}/businesses-gateway/merchant/1.0/acc/check_user`

router.beforeEach((to, from, next) => {
  setTitle(to.meta)
  NProgress.start()
  if (MC.getAuth()) {
    if (to.path === '/app-login') {
      if (MC.getAuth()) {
        next({ path: '/home' })
      } else {
        next({ path: to.path })
      }
      NProgress.done()
    } else {
      if (store.state.common.resList.length === 0) {
        // 判断当前用户是否已拉取完user_info信息
        store.dispatch('common/getBusinessInfo').then(async res => {
          store.commit('common/setShowTrue', true)
          store.dispatch('common/onLoginFanr', {
            'userAccount': res.account,
            'access-token': MC.getAuth(),
            'url': frLoginPath // login fr
          })
          if (to.path === '/app-error401' || to.path === '/home') {
            next()
          }
          if (_.isEmpty(store.state.common.resList)) {
            next({ path: '/app-error401' })
          } else {
            next({ ...to, replace: true })
          }
        }).catch((err) => {
          console.log(err)
          store.dispatch('common/logOut')
        })
      } else {
        if (to.path === '/' || to.path === '/app-login') {
          store.commit('common/setShowTrue', true)
          next({ path: '/home', replace: true })
        } else {
          next()
        }
      }
    }
  } else {
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next(`/app-login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
      // token失效之后 无法重定向至 登录页
      if (to.path !== '/' && from.path !== '/') {
        Message.error({
          message: '验证错误， 请重新登录',
          duration: 3000,
          onClose: () => {
            location.reload()
          }
        })
      }
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})



// WEBPACK FOOTER //
// ./src/js/module/permission/index.js